export const NAME = 'audioGenerationQueue';
